@if (usuario()) {  
  <p-toast></p-toast>
  <form [formGroup]="usuarioForm" (submit)="setUsuario()">
    <div class="mb-4">
      <div class="bg-white rounded-lg shadow-sm p-4">

        <p-fieldset>
          <ng-template pTemplate="header">
            <div class="flex items-center text-primary">
              <i class="pi pi-user mr-2"></i>
              <span class="font-bold text-sm">Informações do Usuário</span>
            </div>
          </ng-template>
          <div class="grid grid-cols-1 md:grid-cols-2 gap-8 mt-4">
            <div class="col-span-1 md:col-span-2">
              <p-floatLabel>
                <input 
                  pInputText 
                  id="login" 
                  formControlName="login" 
                  class="w-full"
                  [readonly]="(usuario().idUsuario ?? 0) > 0 || !flagAdd()" />
                <label for="login">Login</label>
              </p-floatLabel>
              @if (usuarioForm.get('login')?.errors?.['required'] && usuarioForm.get('login')?.touched) {
                <small class="text-red-500 text-xs mt-1 block">Login é obrigatório.</small>
              }
              @if (usuarioForm.get('login')?.errors?.['maxlength']) {
                <small class="text-red-500 text-xs mt-1 block">Máximo 100 caracteres.</small>
              }
            </div>
            <div class="col-span-1 md:col-span-1">
              <p-floatLabel>
                <input 
                  pInputText 
                  id="nome" 
                  formControlName="nome" 
                  class="w-full" />
                <label for="nome">Nome</label>
              </p-floatLabel>
              @if (usuarioForm.get('nome')?.errors?.['required'] && usuarioForm.get('nome')?.touched) {
                <small class="text-red-500 text-xs mt-1 block">Nome é obrigatório.</small>
              }
              @if (usuarioForm.get('nome')?.errors?.['maxlength']) {
                <small class="text-red-500 text-xs mt-1 block">Máximo 500 caracteres.</small>
              }
            </div>
            <div class="col-span-1 md:col-span-1">
              <p-floatLabel>
                <input 
                  pInputText 
                  id="email" 
                  type="email"
                  formControlName="email" 
                  class="w-full" />
                <label for="email">Email</label>
              </p-floatLabel>
              @if (usuarioForm.get('email')?.errors?.['required'] && usuarioForm.get('email')?.touched) {
                <small class="text-red-500 text-xs mt-1 block">Email é obrigatório.</small>
              }
              @if (usuarioForm.get('email')?.errors?.['email']) {
                <small class="text-red-500 text-xs mt-1 block">Email inválido.</small>
              }
              @if (usuarioForm.get('email')?.errors?.['maxlength']) {
                <small class="text-red-500 text-xs mt-1 block">Máximo 500 caracteres.</small>
              }
            </div>
          </div>
        </p-fieldset>

        <p-fieldset>
          <ng-template pTemplate="header">
            <div class="flex items-center text-primary">
              <i class="pi pi-lock mr-2"></i>
              <span class="font-bold text-sm">Alterar Senha</span>
            </div>
          </ng-template>

          <div class="grid grid-cols-1 md:grid-cols-2 gap-8 mt-4">
            <div class="col-span-1 md:col-span-2">
              <p-floatLabel>
                <p-iconfield iconPosition="right">
                  <p-inputicon 
                    [styleClass]="'cursor-pointer'" 
                    (click)="togglePasswordVisibility()">
                    @if (showPassword()) {
                      <i class="pi pi-eye-slash"></i>
                    } @else {
                      <i class="pi pi-eye"></i>
                    }
                  </p-inputicon>
                  <input 
                    pInputText 
                    id="senha" 
                    formControlName="senha" 
                    [type]="passwordType()"
                    class="w-full" />
                </p-iconfield>
                <label for="senha">Senha Atual</label>
              </p-floatLabel>
              @if (usuarioForm.get('senha')?.errors?.['required'] && usuarioForm.get('senha')?.touched) {
                <small class="text-red-500 text-xs mt-1 block">Senha é obrigatória.</small>
              }
              @if (usuarioForm.get('senha')?.errors?.['minlength']) {
                <small class="text-red-500 text-xs mt-1 block">Mínimo 3 caracteres.</small>
              }
            </div>
            <div class="col-span-1 md:col-span-1">
              <p-floatLabel>
                <p-iconfield iconPosition="right">
                  <p-inputicon 
                    [styleClass]="'cursor-pointer'" 
                    (click)="togglePasswordVisibility()">
                    @if (showPassword()) {
                      <i class="pi pi-eye-slash"></i>
                    } @else {
                      <i class="pi pi-eye"></i>
                    }
                  </p-inputicon>
                  <input 
                    pInputText 
                    id="novaSenha" 
                    formControlName="novaSenha" 
                    [type]="passwordType()"
                    class="w-full" />
                </p-iconfield>
                <label for="novaSenha">Nova Senha</label>
              </p-floatLabel>
              @if (usuarioForm.get('novaSenha')?.errors?.['required'] && usuarioForm.get('novaSenha')?.touched) {
                <small class="text-red-500 text-xs mt-1 block">Senha é obrigatória.</small>
              }
              @if (usuarioForm.get('novaSenha')?.errors?.['minlength']) {
                <small class="text-red-500 text-xs mt-1 block">Mínimo 3 caracteres.</small>
              }
            </div>
            <div class="col-span-1 md:col-span-1">
              <p-floatLabel>
                <p-iconfield iconPosition="right">
                  <p-inputicon 
                    [styleClass]="'cursor-pointer'" 
                    (click)="togglePasswordVisibility()">
                    @if (showPassword()) {
                      <i class="pi pi-eye-slash"></i>
                    } @else {
                      <i class="pi pi-eye"></i>
                    }
                  </p-inputicon>
                  <input 
                    pInputText 
                    id="confirmarSenha" 
                    formControlName="confirmarSenha" 
                    [type]="passwordType()"
                    class="w-full" />
                </p-iconfield>
                <label for="confirmarSenha">Repetir Senha</label>
              </p-floatLabel>
              @if (usuarioForm.get('confirmarSenha')?.errors?.['required'] && usuarioForm.get('confirmarSenha')?.touched) {
                <small class="text-red-500 text-xs mt-1 block">Confirmação de senha é obrigatória.</small>
              }
              @if (usuarioForm.get('confirmarSenha')?.errors?.['minlength']) {
                <small class="text-red-500 text-xs mt-1 block">Mínimo 3 caracteres.</small>
              }
              @if (usuarioForm.errors?.['senhasDiferentes'] && usuarioForm.get('confirmarSenha')?.touched) {
                <small class="text-red-500 text-xs mt-1 block">As senhas não conferem.</small>
              }
            </div>
          </div>
        </p-fieldset>
      </div>
    </div>
    <div class="bg-white rounded-lg shadow-sm p-4 mt-4">
      <div class="flex justify-end gap-2">
        <p-button
            label="Cancelar"
            icon="pi pi-times"
            (onClick)="hideDialog(true)"            
            [outlined]="true">
        </p-button>
        <p-button 
          type="submit" 
          label="Confirmar" 
          icon="pi pi-check" 
          severity="primary"
          styleClass="w-32"
          [disabled]="usuarioForm.invalid || flagDisabled()">
        </p-button>
      </div>
    </div>
  </form>
}